// Shared account scope for visual/accessibility preferences. Preferences are
// local to this device, but never global to every profile on it.

import { createSignal } from 'solid-js';

type AppearanceLoader = () => void;

const [activeAppearanceAccountId, setActiveAppearanceAccountId] = createSignal<number | null>(null);
const loaders = new Set<AppearanceLoader>();

export function registerAppearanceLoader(loader: AppearanceLoader): void {
  loaders.add(loader);
}

export function activateAppearanceForAccount(accountId: number): void {
  if (activeAppearanceAccountId() === accountId) return;
  setActiveAppearanceAccountId(accountId);
  for (const loader of loaders) loader();
}

/** Clear profile-specific display choices before showing a shared route such
 * as sign-in or the account picker. This prevents the last signed-in
 * profile's theme, contrast, font size, or palette appearing for somebody
 * who has not signed in yet. */
export function clearActiveAppearanceAccount(): void {
  if (activeAppearanceAccountId() === null) return;
  setActiveAppearanceAccountId(null);
  for (const loader of loaders) loader();
}

export function appearanceStorageKey(name: string): string | null {
  const accountId = activeAppearanceAccountId();
  return accountId === null ? null : `chorepop:account:${accountId}:${name}`;
}
